import Element from './abstract/element';
import ImageFactory from '../../../factory/images';
import { getYoutubeCode } from '../../../utils/youtube';

module.exports = Video;

function Video () {}

Video.prototype = new Element();
Video.prototype.constructor = Video;

Video.prototype.initialize = function () {
  Element.prototype.initialize.call(this);

  this.structure = _.extend(this.structure, {
    autoplay: null,
    controls: null,
    duration: null,
    fullscreen: null,
    height: null,
    loop: null,
    movetonext: null,
    mute: null,
    source: null,
    thumbnail: null,
    url: null,
    width: null,
    x: null,
    y: null,
    youtube: false
  });
};

Video.prototype.getSource = function () {
  const url = this.element.getAttribute('xlink:href');
  return this._getYoutubeCode(url) || url;
};

Video.prototype.getThumbSrc = function () {
  const image = $(this.element).children('image')[0];
  if (!image) return null;

  const src = image.getAttribute('xlink:href');
  return ImageFactory.getVersionUrl(src, 'thumb');
};

Video.prototype.getAutoplay = function () { return this.element.classList.contains('autoplay'); };
Video.prototype.getMovetonext = function () { return this.element.classList.contains('movetonext'); };
Video.prototype.getControls = function () { return this.element.classList.contains('controls'); };
Video.prototype.getFullscreen = function () { return this.element.classList.contains('fullscreen'); };
Video.prototype.getLoop = function () { return this.element.classList.contains('loop'); };
Video.prototype.getMute = function () { return this.element.classList.contains('mute'); };
Video.prototype.getYoutube = function () { return !!(this._getYoutubeCode(this.element.getAttribute('xlink:href'))); };

Video.prototype._getYoutubeCode = getYoutubeCode;
